class ProductSlideshow {
  constructor(container) {
    this.container = container;
    this.slides = container.querySelectorAll('.product__slide');
    this.dots = container.querySelectorAll('[data-slideshow-dot]');
    this.prevButton = container.querySelector('[data-slideshow-prev]');
    this.nextButton = container.querySelector('[data-slideshow-next]');
    this.currentSlide = 0;
    this.autoplayInterval = null;
    this.autoplayDelay = 5000; // 5 seconds
    this.isVideoPlaying = false;
    this.videoEventListeners = new Map(); // Store event listeners for cleanup
    
    // Remove any existing slick initialization
    if (this.container.classList.contains('slick-initialized')) {
      $(this.container).slick('unslick');
    }
    
    this.init();

    // If first slide is a video, play it
    const firstVideo = this.slides[0].querySelector('video');
    if (firstVideo) {
      this.playVideo(firstVideo);
    } else {
      this.startAutoplay();
    }

    // Pause autoplay on hover
    this.container.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.container.addEventListener('mouseleave', () => {
      // Only start autoplay if no video is currently playing
      if (!this.isVideoPlaying) {
        this.startAutoplay();
      }
    });
  }

  init() {
    // Remove any inline styles that might have been added
    this.slides.forEach(slide => {
      slide.removeAttribute('style');
      
      // Initialize videos with proper attributes
      const video = slide.querySelector('video');
      if (video) {
        video.removeAttribute('loop');
        video.loop = false;
        video.playsInline = true; // Better mobile behavior
        video.muted = true; // Autoplay works better with muted
        video.preload = 'auto'; // Ensure video is preloaded
        
        // Store initial event listeners
        const playingListener = () => {
          this.isVideoPlaying = true;
          this.pauseAutoplay();
        };
        
        const endedListener = () => {
          this.isVideoPlaying = false;
          // Advance to next slide when video ends
          setTimeout(() => this.nextSlide(), 250);
        };
        
        // Store listeners for later cleanup
        this.videoEventListeners.set(video, {
          playing: playingListener,
          ended: endedListener
        });
        
        video.addEventListener('playing', playingListener);
        video.addEventListener('ended', endedListener);
      }
    });

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', () => {
        this.previousSlide();
        this.pauseAutoplay();
      });
      this.nextButton.addEventListener('click', () => {
        this.nextSlide();
        this.pauseAutoplay();
      });
    }

    this.dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        const index = parseInt(e.target.getAttribute('data-slideshow-dot'));
        this.goToSlide(index);
        this.pauseAutoplay();
      });
    });
  }

  playVideo(video) {
    if (!video) return;
    
    video.currentTime = 0;
    
    // Ensure video is ready to play
    const playAttempt = () => {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log("Video play failed:", error);
          // If autoplay fails, try again after a short delay
          setTimeout(() => {
            if (!this.isVideoPlaying) {
              playAttempt();
            }
          }, 250);
        });
      }
    };

    // Start playing the video
    playAttempt();
  }

  startAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
    this.autoplayInterval = setInterval(() => {
      // Only advance if no video is playing
      if (!this.isVideoPlaying) {
        this.nextSlide();
      }
    }, this.autoplayDelay);
  }

  pauseAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  goToSlide(index) {
    // Remove active state from current slide
    this.slides[this.currentSlide].classList.add('is-hidden');
    this.dots[this.currentSlide].classList.remove('is-active');
    
    // Stop any currently playing video in the previous slide
    const currentVideo = this.slides[this.currentSlide].querySelector('video');
    if (currentVideo) {
      currentVideo.pause();
      currentVideo.currentTime = 0;
      this.isVideoPlaying = false;
    }
    
    this.currentSlide = index;
    
    // Add active state to new slide
    this.slides[this.currentSlide].classList.remove('is-hidden');
    this.dots[this.currentSlide].classList.add('is-active');

    // Handle video in new slide
    const newVideo = this.slides[this.currentSlide].querySelector('video');
    if (newVideo) {
      this.playVideo(newVideo);
    } else {
      // If it's not a video slide, make sure autoplay is running
      this.startAutoplay();
    }
  }

  nextSlide() {
    const next = (this.currentSlide + 1) % this.slides.length;
    this.goToSlide(next);
  }

  previousSlide() {
    const prev = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(prev);
  }

  // Clean up method to remove event listeners
  destroy() {
    this.pauseAutoplay();
    
    // Clean up video event listeners
    this.slides.forEach(slide => {
      const video = slide.querySelector('video');
      if (video && this.videoEventListeners.has(video)) {
        const listeners = this.videoEventListeners.get(video);
        video.removeEventListener('playing', listeners.playing);
        video.removeEventListener('ended', listeners.ended);
      }
    });
    
    this.videoEventListeners.clear();
  }
}

// Initialize all slideshows on the page
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-slideshow]').forEach(slideshow => {
    const wrapper = slideshow.closest('.product__slides-wrapper');

    // Only the product-slideshow-base markup uses this class. Other product
    // templates render a slick-powered slideshow with no wrapper and no
    // .product__slide children, so leave those alone.
    if (!wrapper || !wrapper.querySelector('.product__slide')) return;

    new ProductSlideshow(wrapper);
  });
}); 